import { render, staticRenderFns } from "./addGroupCode.vue?vue&type=template&id=c9970c5c&scoped=true&"
import script from "./addGroupCode.vue?vue&type=script&lang=js&"
export * from "./addGroupCode.vue?vue&type=script&lang=js&"
import style0 from "./addGroupCode.vue?vue&type=style&index=0&id=c9970c5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9970c5c",
  null
  
)

export default component.exports